import React from "react";
import styled from "styled-components";

export default styled.p`
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 38px;
    color: #273644;
    font-weight: 700;
    margin: 0;
`;